//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { toastNotificationsActions } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';

export const addFeedPreviewExportProgressToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Downloading PDF',
    type: ToastType.SUCCESS,
    message:
      "Your feed preview PDF is downloading. It should take about 10 seconds and will download automatically when it's ready.",
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};

export const addFeedPreviewExportFailureToast = () => {
  return toastNotificationsActions.addToastNotification({
    title: 'Download Failed',
    type: ToastType.ERROR,
    message: 'Your feed preview PDF failed to download. Try again later!',
    options: {
      toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
    },
  });
};
